<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
import { IconType } from '$shared/constants/IconType';
  import SortDirection from '$provider/lib/apis/models/SortDirection';
  import { MinColWidth } from '$shared/constants/DataTableConstants';

  interface Props {
    col: ColumnType;
    activeSortColumn?: boolean;
    sortDirection?: SortDirection;
    onsort?: () => void;
  }

  let { col, activeSortColumn = false, sortDirection = SortDirection.Asc, onsort }: Props = $props();

  let isSortAcs = $derived(sortDirection === SortDirection.Asc);

  const onClickSort = () => {
    onsort?.();
  };
</script>

<th data-cy={`${col.label}-th`} class="data-table-header" width={`${col.width || MinColWidth}px`}>
  <div class="col-cell">
    <div data-cy={col.label} class="label">{col.label}</div>
    {#if col.sortable}
      <div class="sort-button">
        <Icon
          name={isSortAcs ? 'sort-asc' : 'sort-desc'}
          type={IconType.Button}
          value="{isSortAcs ? 'icon-arrow-down' : 'icon-arrow-up'} {activeSortColumn
            ? 'active'
            : 'grey'}"
          onclick={onClickSort}
        />
      </div>
    {/if}
  </div>
</th>

<style>
  .col-cell {
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    line-height: 34px;
    padding: 0 8px 0px;
    border-bottom: 1px solid #e2e4e8;
  }
  .sort-button {
    margin-left: 4px;
  }
</style>
